const DownloadIcon = ({ width = '22', height = '22' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2052 8.53345C18.3807 8.8069 19.6774 10.4388 19.6774 14.0113V14.1259C19.6774 18.0689 18.0984 19.6479 14.1555 19.6479H8.41303C4.47006 19.6479 2.89111 18.0689 2.89111 14.1259V14.0113C2.89111 10.4652 4.17015 8.83336 7.29277 8.54227"
      stroke="#7E858F"
      strokeWidth="2.11703"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2891 2.44702V13.8084"
      stroke="#7E858F"
      strokeWidth="2.11703"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.244 11.8413L11.289 14.7963L8.33398 11.8413"
      stroke="#7E858F"
      strokeWidth="2.11703"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownloadIcon;
